import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, model, Signal, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import {
  AtButtonDirective,
  AtHeaderComponent,
  AtIconComponent,
  AtSidenavComponent,
  BREAKPOINTS,
  COMMON_DICTIONARY,
  CommonDictionary,
  ConfigurableAuthService,
  matchMediaQuery,
} from '@anothertrip/anothertrip-ds';
import { filter, map } from 'rxjs';

import { LoadingService } from '../../services/loading.service';
import { DashboardNavComponent } from '../dashboard-nav/dashboard-nav.component';
import { UserOverlaySelectComponent } from '../user-overlay-select/user-overlay-select.component';

@Component({
  selector: 'app-header-wrapper',
  standalone: true,
  imports: [
    NgOptimizedImage,
    AtHeaderComponent,
    AtButtonDirective,
    RouterLink,
    AtSidenavComponent,
    AtIconComponent,
    DashboardNavComponent,
    UserOverlaySelectComponent,
  ],
  templateUrl: './header-wrapper.component.html',
  styleUrl: './header-wrapper.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'header-wrapper-host',
  },
})
export class HeaderWrapperComponent {
  private readonly authService = inject(ConfigurableAuthService);
  private readonly router = inject(Router);
  private readonly loadingService = inject(LoadingService);
  protected readonly dictionary = inject<CommonDictionary>(COMMON_DICTIONARY).header;

  protected readonly isLoggedIn: Signal<boolean> = this.authService.isLoggedIn;

  protected readonly sidenavOpen = model<boolean>(false);
  /** The drawer's id, so the header's menu button can point `aria-controls` at it. */
  protected readonly sidenavPanelId = 'dashboard-nav-drawer';

  protected readonly isDesktop = matchMediaQuery(`(min-width: ${BREAKPOINTS.XL + 1}px)`);

  protected readonly isMobile = matchMediaQuery(`(max-width: ${BREAKPOINTS.XS}px)`);

  protected readonly showSidenav = computed<boolean>(() => !this.isDesktop() && this.isLoggedIn());

  protected readonly isSignIn = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects.includes('/login'))
    )
  );

  protected readonly showLoadingBar: Signal<boolean> = this.loadingService.isLoading;

  protected toggleSidenav(): void {
    this.sidenavOpen.update((prev) => !prev);
  }
}
